import { SEARCHABLE_CASHREGISTER_FIELDS } from '../../constant/constants';
import { matchesSearch } from '../../util/matches-search';

export interface CashRegisterItem {
  GroupID: string | null;
  GroupName: string;
  LocationID: string;
  LocationName: string;
  DeviceID: string;
  DeviceName: string;
  StartState: number;
  Changes: number;
  EndState: number;
  Currency: string;
}

export interface CashRegisterDataResponse {
  Collection: CashRegisterItem[];
  Total: number;
  AdditionalInformation: {
    SumOfJackpot: number;
    SumOfStartJackpot: number;
  };
  ResponseCode: number;
  Message: string;
}

export interface Game {
  GameName: string;
  PayIn: number;
  PayInAfterTax: number;
  PayOut: number;
  PayOutAfterTax: number;
  NumberOfTickets: number;
  Balance: number;
}

export interface PayInPayOut {
  FullName: string;
  PayIn: number;
  PayOut: number;
  Balance: number;
}

export interface Manager {
  PayInPayOutSum: FinancialSummary[];
  PayInPayOut: PayInPayOut[];
}

export interface FinancialSummary {
  Balance: number;
  PayIn: number;
  PayOut: number;
}

export interface Name {
  UserName: string;
  FullName: string;
}

export interface Operator {
  VoucherSum: FinancialSummary;
  AndroidVoucherSum: FinancialSummary;
  OperatorNames?: Name[];
}

export function searchCashRegisterData(
  cashRegisterDataResponse: CashRegisterDataResponse | null,
  searchTerm: string,
): CashRegisterDataResponse {
  if (!cashRegisterDataResponse || !searchTerm) {
    return cashRegisterDataResponse as CashRegisterDataResponse;
  }

  const term = searchTerm.toLowerCase();

  const filteredItems = cashRegisterDataResponse.Collection.filter((item) =>
    SEARCHABLE_CASHREGISTER_FIELDS.some((field) => matchesSearch(item[field], term)),
  );

  return {
    ...cashRegisterDataResponse,
    Collection: filteredItems,
    Total: filteredItems.length,
  };
}
